import { Icon, IconComponent } from '@graftcode/design-system'

import styles from './NoResultsState.module.scss'

interface NoResultsStateProps {
  title?: string
  message?: string
}

const DEFAULT_TITLE = 'No results found'
const DEFAULT_MESSAGE = 'Try a different search term'

export function NoResultsState({ title = DEFAULT_TITLE, message = DEFAULT_MESSAGE }: NoResultsStateProps) {
  return (
    <div className={styles.container}>
      <IconComponent icon={Icon.SearchRegular} className={styles.icon} />
      <span className={styles.title}>{title}</span>
      <span className={styles.message}>{message}</span>
    </div>
  )
}
